import { render } from "./RoleSheetView.vue?vue&type=template&id=a757bce8&ts=true"
import script from "./RoleSheetView.vue?vue&type=script&lang=ts"
export * from "./RoleSheetView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__